import { SlideAction } from "./slide-action.model";
import { MainConfig } from "@atenea-cms";
export class Slide {
  _id?: string;
  image: string = "";
  video: string = "";
  mediaPosition: "top" | "right" | "bottom" | "left" | "center" = "left";
  title: string = "";
  content: string = "";
  secondaryContent: string = "";
  contentPosition: "top" | "right" | "bottom" | "left" | "center" = "right";
  backgroundImage: string = "";
  backgroundVideo: string = "";
  backgroundPosition: "top" | "right" | "bottom" | "left" | "center" = "center";
  backgroundFixed: boolean = false;
  backgroundColor: string = "";
  backgroundColorSecondary: string = "";
  backgroundPatternAligment:
    | "none"
    | "left"
    | "center"
    | "right"
    | "full_width" = "none";
  backgroundPatternStyle: "light" | "dark" = "light";
  backgroundColorAlias: string;
  height: "auto" | "viewport" = "auto";
  textColor: "light" | "dark" = "light";
  textBackground: "none" | "light" | "dark" = "none";
  actions: Array<SlideAction> = [];
  actionsAlign: "left" | "center" | "right" = "left";
  position: number = 0;
  active: boolean = true;
  vintageMode: boolean = false;

  constructor(backgroundColorAliasDefault: string = "white") {
    this.backgroundColorAlias = backgroundColorAliasDefault;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/common/models/slide.model.ts